import moment from 'moment'

class SingleServiceTime {
  private static instance: SingleServiceTime | null = null
  clientServerDateDiff: number

  constructor() {
    this.clientServerDateDiff = 0
  }

  static getInstance() {
    if (!SingleServiceTime.instance) {
      SingleServiceTime.instance = new SingleServiceTime()
    }
    return SingleServiceTime.instance
  }

  get serviceDate() {
    return moment(Date.now() + this.clientServerDateDiff)
  }
}

export default SingleServiceTime.getInstance()
